<template>
  <div class="bg-white">
    <navigation-bar />
    <breadcrumb :serviceId="store.state.serviceSlug" />
    <div
      v-if="
        store.state.service.accountRequired == 1 &&
        store.state.currentUserId < 1
      "
      class="container-fluid"
      style="min-height: 200px"
    >
      <h1 style="margin-top: 10px">Account Required</h1>
      <p style="margin-top: 20px">
        You must
        <router-link to="/account/register">Create an Account</router-link> to
        view this page.
      </p>
    </div>
    <div v-else class="container-fluid">
      <div
        class="row"
        style="min-height: 690px"
        v-if="!store.state.selectedCustomer"
      >
        <div class="col-sm-12">
          <div class="search-bar" style="margin-bottom: 0px">
            <br />
            <div class="row">
              <div class="col-sm-12">
                <button
                  class="btn btn-blue"
                  @click="changeMode"
                  style="text-align: left; float: right;color:white;border-radius:10px;width:40px;height:40px;"
                >
                  <i v-if="store.state.mode == 'Table'" class="fa fa-photo" />
                  <i v-else class="fa fa-table" />
                </button>
              </div>
            </div>

            <h1 class="text-left">{{ store.state.service.name }}</h1>
            <p class="text-left">{{ store.state.service.description }}</p>
            <br />
            <br />
            <feed-search
              :fields="store.state.fields"
              :showSearch="store.state.showSearch"
              :service="store.state.service"
              :stateSearchForm="store.state.stateSearchForm"
              @clearSearch="clearSearch"
              @search="search"
              @showSearch="showSearch"
              :sortedField="store.state.sortedField"
              :sortedDirection="store.state.sortedDirection"
              @sortBy="sortBy"
            />

            <div class="row" style="margin-top: 0px">
              <div class="col-xs-12 col-sm-12">
                <div v-if="store.state.service.archiveAfterCompletion == 1">
                  <h1
                    v-if="store.state.type == 'Active'"
                    style="text-align: left"
                  >
                    Active Listings
                  </h1>
                  <h1
                    v-if="store.state.type == 'Archive'"
                    style="text-align: left"
                  >
                    Archived Listings
                  </h1>
                  <button
                    style="float: left"
                    v-if="store.state.type == 'Active'"
                    @click="changeListingFilter('Archive')"
                    class="btn btn-primary btn-orange"
                  >
                    Show Archived Listings
                  </button>
                  <button
                    style="float: left"
                    v-if="store.state.type == 'Archive'"
                    @click="changeListingFilter('Active')"
                    class="btn btn-primary btn-orange"
                  >
                    Show Active Listings
                  </button>
                </div>
                <div v-if="listings().length > 0">
                  <feed-table
                    v-if="store.state.mode == 'Table'"
                    :listings="listings()"
                    :fields="store.state.fields"
                    :showSearch="store.state.showSearch"
                    @sortBy="sortBy"
                    @favorite="favorite"
                    @unfavorite="unfavorite"
                    @showSearch="showSearch"
                    @showInfo="showInfo"
                  />

                  <feed-cards
                    v-else
                    :listings="listings()"
                    :fields="store.state.fields"
                    :showSearch="store.state.showSearch"
                    @favorite="favorite"
                    @unfavorite="unfavorite"
                    @showSearch="showSearch"
                    @showInfo="showInfo"
                    :key="cardKey"
                  />
                </div>
                <div v-else>No listings found, please check back soon.</div>
                <div></div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "./nav/NavigationBar";
import Breadcrumb from "./nav/Breadcrumb";
import Store from "./FeedStore";
import API from "@/API/API";
import DashboardFooter from "./nav/Footer";
import Utils from "@/Utils/Utils";
import AccountSessionUtils from "@/components/account/AccountSessionUtils";
import FeedTable from "./FeedTable.vue";
import FeedSearch from "./FeedSearch.vue";
import FeedCards from "./FeedCards.vue";
export default {
  name: "Feed",
  components: {
    NavigationBar,
    DashboardFooter,
    Breadcrumb,
    FeedTable,
    FeedSearch,
    FeedCards,
  },
  data() {
    return {
      store: Store,
      api: API,
      accountUtils: AccountSessionUtils,
      utils: Utils,
      cardKey: 0,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.store.state.serviceSlug = to.params.serviceId;
    this.init();
    next();
  },
  mounted() {
    this.store.state.serviceSlug = this.$route.params.serviceId;
    this.init();
  },
  computed: {
    tableFields() {
      let fields = this.store.state.fields.filter((it) => {
        return it.showInTable == 1;
      });
      if (!fields) {
        return [];
      }

      return fields;
    },
    numColumns() {
      return this.tableFields.length;
    },
    searchableFields() {
      return this.store.state.fields.filter((it) => {
        return it.searchable == 1;
      });
    },
  },
  methods: {
    init() {
      this.accountUtils.authorize(
        (userId) => {
          this.store.state.currentUserId = userId;
          this.populate();
        },
        (err) => {
          this.populate();
        }
      );
    },
    populate() {
      this.store.state.listings = [];
      this.store.state.fields = [];
      this.store.state.service = {};
      // this.store.state.serviceSlug = this.$route.params.serviceId;
      this.store.getServiceBySlug(
        () => {
          this.getListings();
          this.getServiceFields();
          this.getService();
        },
        () => {},
        () => {}
      );
    },
    getListings() {
      this.clearSearch();
      this.store.getListings(
        (data) => {
          if (this.store.state.serviceId == 1) {
            let field = this.store.state.fields.find((it) => {
              return it.id == 5;
            });

            if (this.store.state.stateSearchForm.value) {
              this.search();
            }
          }
        },
        (err) => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }
      );
    },
    getService() {
      this.store.getService(
        (data) => {},
        (err) => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }
      );
    },
    getServiceFields() {
      this.store.getServiceFields(
        (data) => {
          if (this.store.state.serviceId == 1) {
            let field = this.store.state.fields.find((it) => {
              return it.id == 5;
            });
          }
        },
        (err) => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }
      );
    },
    findShowInTableFromField(listing, fieldName) {
      var value = "";
      listing.fields.forEach((field) => {
        if (field.name == fieldName) {
          value = field.showInTableOnSmall;
        }
      });
      return value == 1 ? true : false;
    },
    showInfo(listing) {
      listing.showInfo = !listing.showInfo;
      this.store.state.listings.map((it) => {
        if (it.id == listing.id) {
          it.showInfo = listing.showInfo;
        }
        return it;
      });
      this.$forceUpdate();
      this.cardKey += 1;
    },
    getImgUrl(pic) {
      return require("@/assets/" + pic);
    },
    favorite(listing) {
      if (this.store.state.currentUserId == 0) {
        this.$toasted.show("Login or create an account to favorite a listing", {
          type: "error",
          duration: 2500,
        });
      } else {
        this.store.favorite(
          listing.id,
          (data) => {
            listing.favorite = true;
            listing.favoriteCount += 1;
          },
          (err) => {
            this.$toasted.show(err, { type: "error", duration: 2500 });
          }
        );
      }
    },
    unfavorite(listing) {
      if (this.store.state.currentUserId == 0) {
        this.$toasted.show("Login or create an account to favorite a listing", {
          type: "error",
          duration: 2500,
        });
      } else {
        this.store.unfavorite(
          listing.id,
          (data) => {
            listing.favorite = false;
            listing.favoriteCount -= 1;
          },
          (err) => {
            this.$toasted.show(err, { type: "error", duration: 2500 });
          }
        );
      }
    },
    clearSearch() {
      this.store.state.citySearchForm.value = "";
      this.store.state.stateSearchForm.value = "";
      this.store.state.fields.forEach((it) => {
        if (it.searchable == 1) {
          it.searchValue = "";
          it.searchValues = [];
          if (it.searchValue_startDate) {
            it.searchValue_startDate = "";
          }

          if (it.searchValue_endDate) {
            it.searchValue_endDate = "";
          }
        }
      });
      this.store.state.filterListings = false;
    },
    search() {
      this.store.search();
    },
    listings() {
      if (this.store.state.filterListings) {
        return this.store.state.filteredListings;
      } else {
        return this.store.state.listings;
      }
    },
    changeListingFilter(type) {
      this.store.state.type = type;
      this.getListings();
    },
    showSearch() {
      console.log("show search");
      this.store.state.showSearch = !this.store.state.showSearch;
    },
    sortBy(field) {
      console.log(field)
      this.store.sortBy(field);
      this.$forceUpdate()
    },
    changeMode() {
      if (this.store.state.mode == "Table") {
        this.store.state.mode = "Card";
      } else {
        this.store.state.mode = "Table";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 768px) {
  .hidden-sm {
    display: none;
  }
}

.white {
  color: white;
}

.search {
  background: #f2f2f2;
  border-radius: 10px;
  margin: 0px;
  padding: 20px;
  margin-bottom: 20px;
}

.small {
  font-size: 90%;
}

.medium {
  font-size: 130%;
}

.large {
  font-size: 170%;
}
</style>



// WEBPACK FOOTER //
// src/components/Feed.vue